import React, { ReactNode } from "react";
import { Button } from "capitalrx-components";
import voca from "voca";

interface Props {
  sectionTitle: string;
  sectionImage: ReactNode;
  buttonText: string;
  path: string;
  handleClick: Function;
}

const TestClaimImageContainer: React.FC<Props> = (props: Props) => {
  const { sectionTitle, sectionImage, buttonText, path, handleClick } = props;
  const dataSelector = voca.snakeCase(buttonText);
  const buttonSelector = `${dataSelector}`;
  const imageSelector = `${dataSelector}_image`;

  return (
    <div className="test-claim-section-with-image caprx-h-center-text">
      <div className="test-claim-section-description mb30">{sectionTitle}</div>
      <Button
        handleClick={(): void => handleClick()}
        data-testid={buttonSelector}
        extraClasses="test-claim-button mb30"
        buttonType="router-link"
        buttonStyle="outline"
        color="darkblue"
        path={path}
      >
        <span className="caprx-icon-input-plus mr5" />
        {buttonText}
      </Button>
      <div data-testid={imageSelector} className="mb10">
        {sectionImage}
      </div>
    </div>
  );
};

export default TestClaimImageContainer;
